import React from 'react';

import '../assets/sass/main.scss';
const Footer = () => (
  <footer id="footer" className="wrapper style1-alt">
    <div className="inner">
      <ul className="menu">
        <li>Ivan Ha &copy; 2019</li>
      </ul>
    </div>
  </footer>
);

export default Footer;
